<template>
  <div class="paid-member-select">
    <div class="select-title">お支払い方法の選択</div>
    <normal-btn
      @click="onMemberRegistration('form1', 1)">d払い</normal-btn>
    <normal-btn
      @click="onMemberRegistration('form1', 2)">auかんたん決済(au / UQ mobile)/au PAY</normal-btn>
    <normal-btn
      @click="onMemberRegistration('form1', 3)">ソフトバンク・ワイモバイル<wbr>まとめて支払い</normal-btn>
    <normal-btn
      @click="onMemberRegistration('form1', 0)">クレジットカード</normal-btn>
    <form enctype="application/json" method="post" :action="url1" ref="form1">
      <input type="hidden" name="accessToken" :value="accessToken"/>
      <input type="hidden" name="reserveId" :value="reserveId"/>
      <input type="hidden" name="payType" :value="payType"/>
    </form>
  </div>
</template>

<script>
import NormalBtn from '../components/NormalBtn'
import Protobuf from '../mixins/protobuf'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "PaidMemberSelect",
  components: {NormalBtn},
  mixins: [Protobuf],
  data () {
    return {
      url1: '',
      url2: '',
      accessToken: '',
      reserveId: '',
      payType: 0,
    }
  },
  methods: {
    onMemberRegistration(form, type) {
      this.setCariorForm(type, () => this.$nextTick(() => this.$refs[form].submit()))
    },
    setCariorForm(type, callback) {
      const cmdNo = pb.BuyMembershipStartReq.CommandNo.COMMAND_NO
      const message = pb.BuyMembershipStartReq.create({
        membershipGrade: 2,
        payType: type
      })
      const encoded = pb.BuyMembershipStartReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === 0) {
            this.url1 = decoded.url
            const json = JSON.parse(decoded.postJson)
            this.accessToken = json.accessToken
            this.reserveId = json.reserveId
            this.payType = json.payType
            callback()
          } else if (decoded.status === pb.BuyMembershipStartResp.Status.ALREADY_PURCHASED) {
            this.$router.push('/paidMemberRegistrationUpdate')
          } else {
            this.$_error('Error', { title: 'お支払い方法の選択', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'お支払い方法の選択', statusCode: 100 })
        })
    }
  }
}
</script>

<style scoped>
</style>
